export function getUrlParams(): Record<string, string> {
  const url = `${window.location.href}`

  const vars: Record<string, string> = {}

  let hash: string[]

  if (url.indexOf('?') !== -1) {
    url
      .slice(url.indexOf('?') + 1)
      .split('&')
      .forEach((c) => {
        hash = c.split(/=(.+)/)
        vars[hash[0].toLowerCase()] = decodeURIComponent(hash[1])
      })
  }

  return vars
}
